/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/require-default-props */
import { useEffect, useState } from 'react';
import { PriorAuthorizationDomainHead } from '../../interfaces/PriorAuthorizationDomain';
import './serviceProvider.component.css';
import { usePADomainModel } from '../../context/ctxPriorAuthorizationDomain';

interface IServiceProviderProps {
  priorAuthDomainHeadObj?: PriorAuthorizationDomainHead
}

const ServiceProvider = ({ priorAuthDomainHeadObj }: IServiceProviderProps) => {
  const { isServiceProviderPhoneValid, setIsServiceProviderPhoneValid } = usePADomainModel();

  const [phone, setPhone] = useState(priorAuthDomainHeadObj?.servicingProvider.phone);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    if (!phone) {
      setIsValid(false);
      setIsServiceProviderPhoneValid(false);
    } else {
      const numericPhone = phone.replace(/\D/g, '');
      const valid = numericPhone.length === 10;
      setIsValid(valid);
      setIsServiceProviderPhoneValid(valid);
    }
  }, [phone]);

  const handlePhoneChange = (e: any) => {
    const newPhone = e.target.value.replace(/\D/g, '').slice(0, 10);
    setPhone(newPhone);
    if (priorAuthDomainHeadObj) {
      priorAuthDomainHeadObj.servicingProvider.phone = newPhone;
    }
  };

  const formatPhoneNumberForDisplay = (input: string | undefined) => {
    if (!input) return '';
    let formatted = '';
    if (input.length > 3) {
      formatted = `(${input.slice(0, 3)}) `;
      if (input.length > 6) {
        formatted += `${input.slice(3, 6)}-${input.slice(6, 10)}`;
      } else {
        formatted += `${input.slice(3)}`;
      }
    } else {
      formatted = input;
    }
    return formatted;
  };

  return (
    <li className="list-group-item">
      <h5>Servicing Provider</h5>
      <div className="row align-items-center d-inline-block d-flex" id="sp-tin-npi-1">
        <div className="col-md-3">
          <label className="fw-bold mb-0" data-testid="tin">TIN</label>
          <p className="p1-0 " id="sp-tin" data-testid="tin-value">{priorAuthDomainHeadObj?.servicingProvider.taxId}</p>
        </div>
        <div className="col-md-auto">
          <label className=" fw-bold mb-0" data-testid="lbl-npi">NPI</label>
          <p className="p1-0 " id="sp-npi" data-testid="val-npi">{priorAuthDomainHeadObj?.servicingProvider.npi}</p>
        </div>
        <div className="col-auto" />
      </div>
      <div className="row align-items-center d-inline-block d-flex " id="sp-name-1">
        <div className="col-md-3">
          <label className="fw-bold mb-0" htmlFor="sp-providername" data-testid="lbl-providerName">Name</label>
          <p className=" pl-0" id="sp-providername" data-testid="val-providerName">{priorAuthDomainHeadObj?.servicingProvider.name}</p>
        </div>
      </div>
      <div className=" " id="sp-contact-info-1">
        <label className=" fw-bold mb-0" htmlFor="sp-address-1" data-testid="lbl-address">Address </label>
        <p className="pl-0 mb-0" id="sp-address-1" data-testid="val-address">
          {' '}
          {priorAuthDomainHeadObj?.servicingProvider.address}
          ,
          {' '}
          <span id="sp-address-2">
            {' '}
            {priorAuthDomainHeadObj?.servicingProvider.address2}
          </span>
        </p>
        <p className="pl-0" id="sp-city" data-testid="val-city">
          {priorAuthDomainHeadObj?.servicingProvider.city}
          ,
          <span id="sp-state" data-testid="val-state">
            {' '}
            {priorAuthDomainHeadObj?.servicingProvider.state}
          </span>
          {' '}
          <span id="sp-zip" data-testid="val-zip">{priorAuthDomainHeadObj?.servicingProvider.zipCode}</span>
        </p>
        <label className=" fw-bold mb-0" htmlFor="sp-phone" data-testid="lbl-phoneNumber">Phone Number</label>
        <input type="tel" className={`form-control ${!isValid ? 'invalid-phone' : ''}`} id="sp-phone" data-testid="service-phone" placeholder="(###) ###-####" value={formatPhoneNumberForDisplay(phone)} onChange={handlePhoneChange} />
        {!isValid && (
        <div className="FieldNote mb-1">
          <div className="Fieldnotebase">
            <div className="font-size-sm invalid-note">
              <span>Please provide a valid phone number.</span>
            </div>
          </div>
        </div>
        )}
      </div>
      <div className="" id="new-phone" style={{ display: 'none' }}>
        <div className="mt-3 mb-2">
          <label className=" font-weight-bold mb-0" htmlFor="sp-phone-1">Phone Number</label>
          <input type="tel" className="form-control" id="sp-phone-1" placeholder="(###) ###-####" value="" />
        </div>
        <div className="d-flex justify-content-start mt-1">
          <button type="button" className="btn-sm btn-tertiary">Remove Phone</button>
        </div>
      </div>
    </li>
  );
};

export default ServiceProvider;
